// Same six categories as the remote exam system (exam.learningfirst.io).
export const SUPPORT_MESSAGE_TYPES = [
  "Tech Issue",
  "Academic",
  "Rule & Compliance",
  "Score & Results",
  "Personal Info",
  "Other",
];

// Older messages were stored with Chinese type values; show them in English.
const LEGACY_MESSAGE_TYPE_LABELS = {
  学术问题: "About Academic",
  流程问题: "About Process",
  数据问题: "About Score",
  系统操作问题: "About System Operation",
  奖项证书问题: "About Award and Certificate",
  其他问题: "Others",
};

export function displayMessageType(type) {
  return LEGACY_MESSAGE_TYPE_LABELS[type] || type || "Other";
}
